import { useEffect } from 'react';

const PORTAL_SUFFIX = ' – Client Portal';

export function usePortalTitle(title: string | undefined) {
  useEffect(() => {
    const prev = document.title;
    document.title = title ? `${title}${PORTAL_SUFFIX}` : 'Client Portal';
    return () => {
      document.title = prev;
    };
  }, [title]);
}
